export default "/images/headphone-icon-blue.png?727004170b8675ce7a3072c3795d6573";